import React from 'react';
import InsurerPhone from '../../../util/InsurerPhone';
import { ACCOUNT_CALL_INSURANCE_BENEFITS } from '../../../../../../../core/analytics/events';
import { Content } from './shared';

type Props = {
  benefitsPhone: string;
  insuranceCarrierDisplayProperties: any;
  insuranceProfile: any;
};

const AetnaNurseHotline = (props: Props) => {
  const { benefitsPhone, insuranceCarrierDisplayProperties, insuranceProfile } = props;
  return (
    <Content>
      Call{' '}
      {benefitsPhone && (
        <span>
          <InsurerPhone
            insuranceCarrierDisplayProperties={insuranceCarrierDisplayProperties}
            insuranceCarrierName={insuranceProfile.insurer_name}
            insurerCode={insuranceProfile.insurer_code}
            insurerPhone={benefitsPhone}
            insurerType={insuranceProfile.insurer_type}
            trackingCode={ACCOUNT_CALL_INSURANCE_BENEFITS}
          />{' '}
        </span>
      )}
      and have your member ID ready.
    </Content>
  );
};

export default AetnaNurseHotline;
